import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from 'containers/layout/Layout'
import Tasks from 'pages/Tasks'
import TaskDetail from 'pages/TaskDetail'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import CreateTask from 'pages/CreateTask'
import Users from 'pages/Users'
import Projects from 'pages/Projects'
import ProjectDetail from 'pages/ProjectDetail'
import CreateProject from 'pages/CreateProject'
import TaskEdit from 'pages/TaskEdit'
import Login from 'pages/Login'
import { ToastContainer } from 'react-toastify'
import BillingStatement from 'pages/BillingStatement'
import PaymentReport from 'pages/PaymentReport'
import InvoiceReport from 'pages/InvoiceReport'
import { locale, addLocale } from 'primereact/api'
import moment from 'moment';
import 'moment/locale/tr';
import NotFound from 'pages/NotFound'
import Home from 'pages/Home'
import SlaReports from 'pages/SlaReports'
import LeasingReport from 'pages/LeasingReport'
import RateReports from 'pages/RateReport'
import Developers from 'pages/Developers'
import ProjectReport from 'pages/ProjectReport'
import EffortAnalysis from 'pages/EffortAnalysis'
import Leave from 'pages/Leave'
import WeeklyPlan from 'pages/WeeklyPlan'
import MasterPlan from "pages/MasterPlan";
import WeeklyPlanDetail from 'pages/WeeklyPlanDetail'
import DeveloperPlanReport from 'pages/DeveloperPlanReport'
import PmPlanReport from 'pages/PmPlanReport'
import LeavesReport from 'pages/LeavesReport'
import LeaveMovementsReport from 'pages/LeaveMovementsReport'
import OutsourceInvoiceReport from 'pages/OutsourceInvoiceReport'
import LeadManagement from 'pages/LeadManagement'
import LeadManagementDetail from 'pages/LeadManagementDetail'
import CrmPage from 'pages/CrmPage'
import CrmDirectory from 'pages/CrmDirectory'
import CrmDetail from 'pages/CrmDetail'
import CrmReminders from 'pages/CrmReminders'

moment.locale('tr',{
		longDateFormat : {
		LT : 'HH:mm',
		LTS : 'HH:mm:ss', 
		L : 'yyyy-MM-DD',
		LD : 'DD.MM.YYYY',
		ll : 'YYYY - MMMM',
		lll : 'MMMM YYYY',
		LL : 'DD.MM.YYYY',
		LLL : 'D MMMM YYYY',
		LLLL : 'D MMMM YYYY dddd',
		LLLLL : 'D MMMM YYYY dddd HH:mm',
	},
  })
function App() {
	const { dark } = useSelector((state) => state.dark)
	
	useEffect(() => {
		const root = document.getElementById('root')
		if (dark) {
			root.classList.add('dark-theme')
		} else {
			root.classList.remove('dark-theme')
		}
	}, [dark])

	useEffect(() => {
		addLocale('tr', {
			firstDayOfWeek: 1,
			dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çaşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
			dayNamesShort: ['Pzr', 'Pzt', 'Salı', 'Çrş', 'Prş', 'Cuma', 'Cts'],
			dayNamesMin: ['Pa', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
			monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
			monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
			today: 'Bugün',
			clear: 'Temizle',
		})
		locale('tr')
	}, [])
	return (
		<BrowserRouter>
			<Routes>
				<Route path='/' element={<Layout />}>
					<Route index element={<Home />} />
					<Route path='tasks'>
						<Route index element={<Tasks />} />
						<Route path='create' element={<CreateTask />} />
						<Route path=':taskId'>
							<Route index element={<TaskDetail />} />
							<Route path='edit' element={<TaskEdit />} />
						</Route>
					</Route>
					<Route path='users' element={<Users />} />
					<Route path='projects'>
						<Route index element={<Projects />} />
						<Route path='create' element={<CreateProject />} />
						<Route path=':projectId'>
							<Route index element={<ProjectDetail />} />
						</Route>
					</Route>
					<Route path='lead-management'>
						<Route index element={<LeadManagement />} />
						<Route path=':leadManagementId'>
							<Route index element={<LeadManagementDetail />} />
						</Route>
					</Route>
					<Route path='crm-management'>
						<Route index element={<CrmPage />} />
						<Route path=':crmId'>
							<Route index element={<CrmDetail />} />
						</Route>
					</Route>
					<Route path='crm-directory'>
						<Route index element={<CrmDirectory />} />
					</Route>
					<Route path='crm-reminders'>
						<Route index element={<CrmReminders />} />
					</Route>
					<Route path='developers' element={<Developers />} />

					<Route path='billing-statement'>
						<Route index element={<BillingStatement />} />
					</Route>
					<Route path='invoice-report'>
						<Route index element={<InvoiceReport />} />
					</Route>
					<Route path='billing-report'>
						<Route index element={<PaymentReport />} />
					</Route>
					<Route path='sla-report'>
						<Route index element={<SlaReports />} />
					</Route>
					<Route path='leasing-report'>
						<Route index element={<LeasingReport />} />
					</Route>
					<Route path='rate-report'>
						<Route index element={<RateReports />} />
					</Route>
					<Route path='project-report'>
						<Route index element={<ProjectReport />} />
						<Route path=':projectId' element={<ProjectReport />} />
					</Route>
					<Route path='developer-plan-report'>
						<Route index element={<DeveloperPlanReport />} />
					</Route>
					<Route path='project-plan-report'>
						<Route index element={<PmPlanReport />} />
					</Route>
					<Route path='leaves-report'>
						<Route index element={<LeavesReport />} />
					</Route>
					<Route path='leave-movements-report'>
						<Route index element={<LeaveMovementsReport />} />
					</Route>
					<Route path='effort-analysis-report'>
						<Route index element={<EffortAnalysis />} />
					</Route>
					<Route path='outsource-invoice-report'>
						<Route index element={<OutsourceInvoiceReport />} />
					</Route>
					<Route path='leave'>
						<Route index element={<Leave />} />
					</Route>
					<Route path='weekly-plan'>
						<Route index element={<WeeklyPlan />} />
						<Route path=':weekId'>
							<Route index element={<WeeklyPlanDetail />} />
						</Route>
					</Route>
					<Route path='master-plan'>
						<Route index element={<MasterPlan />} />
					</Route>
				</Route>
				<Route path='unauthorized' element={<NotFound/>} />
				<Route path='*' element={<NotFound/>} />
				<Route path='login' element={<Login />} />
			</Routes>
			<ToastContainer position='top-right' autoClose={5000} closeOnClick theme='light' />
		</BrowserRouter>
	)
}

export default App
